var embed = {};

embed.init = function () {
	if ($('.embed-container iframe').length >= 1) {
		$('.embed-container iframe').each(function () {
			var $this = $(this),
				src = $this.attr('src');
			if (src.includes('vimeo') || str.includes("youtu")) {
				$this.closest('.embed-container').addClass('is-video');
			}
		});
	}
}

export { embed };
